export const PAGE_KEY = 'attendance-user-my-requests';
